import React from 'react'
import { Link } from 'react-router-dom'


export default function Buttonhero() {
  return (
    
    <Link to="/Shop">
      <button className="btn btn-info text-primary-content">Comencemos</button>
    </Link>
    
  )
}
